export default "__VITE_ASSET__CJ22M85m__";